import Currency from "./Currency";
import { BusinessAccountAttributes } from "../attributes/business-account-attributes";

class BusinessAccount {
  id: number;
  balance: number;
  wallet_type: number;

  currency: Currency;

  constructor(
    id: number,
    balance: number,
    wallet_type: number,
    currency: Currency
  ) {
    this.balance = balance;
    this.wallet_type = wallet_type;
    this.currency = currency;
  }

  static fromJson(json: BusinessAccountAttributes) {
    if (json === null || json === undefined) {
      return null;
    }

    return new BusinessAccount(
      json.id,
      json.balance,
      json.wallet_type,
      Currency.fromJson(json.currency)
    );
  }
}

export default BusinessAccount;
